import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('PolicyViolationTransportDataModel')
export default class PolicyViolationTransportDataModel {
  @JsonProperty('price', Number) public price:number = undefined;
  @JsonProperty('travel_class', String) public travelClass:string = undefined;
  @JsonProperty('travel_length', String, true) public travelLength:string = undefined;
  @JsonProperty('policy_price', Number) public policyPrice:number = -1;
}
